import { render, staticRenderFns } from "./search.vue?vue&type=template&id=794e9ee2&scoped=true&"
import script from "./search.vue?vue&type=script&lang=js&"
export * from "./search.vue?vue&type=script&lang=js&"
import style0 from "./search.vue?vue&type=style&index=0&id=794e9ee2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "794e9ee2",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SearchArticlePreviewBlock: require('/app/components/article/SearchArticlePreviewBlock.vue').default})
